import DraggableModal from 'components/organisms/draggableModal';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import s from '../../styles.module.scss';

type IAlertDraggableModalProps = {
  isOpen: boolean;
  handleOk: () => void;
  toggle: (state?: boolean) => void;
  children: ReactNode;
};

const AlertDraggableModal = ({
  handleOk,
  isOpen,
  toggle,
  children,
}: IAlertDraggableModalProps) => {
  const { t } = useTranslation();
  return (
    <DraggableModal
      modalClassName={s['alert-modal-window']}
      isOpen={isOpen}
      title={t('labels.alert')}
      toggle={toggle}
      saveLabel={t('labels.confirm')}
      onSave={handleOk}
    >
      {children}
    </DraggableModal>
  );
};

export default AlertDraggableModal;
